module.exports = __webpack_public_path__ + "130e1fbc21d527e909206bf846ca310c.jpg";